import { MutationTree } from 'vuex';
import { ProductsState } from '@/types/state';
import { ProductInterface } from '@/types/product';

const mutations: MutationTree<ProductsState> = {
  setDataLoaded(state) {
    state.isDataLoaded = true;
  },

  setProducts(state, products) {
    state.products = products;
  },

  addProduct(state, product: ProductInterface) {
    state.products.push(product);
  },

  updateProduct(state, product: ProductInterface) {
    const productIndex = state
      .products
      .map((prod) => prod.id)
      .indexOf(product.id);

    if (productIndex > -1) {
      state.products.splice(productIndex, 1, product);
    }
  },

  deleteProduct(state, product) {
    const productIndex = state
      .products
      .map((prod) => prod.id)
      .indexOf(product.id);

    if (productIndex > -1) {
      state.products.splice(productIndex, 1);
    }
  },

};

export default mutations;
